import { connect } from 'react-redux'
import ListFromTable from 'components/common/ListFromTable'
import {
  auditFetchTable,
  auditFetchTableFilters,
  auditClearStateList,
} from 'reducers/audit/reducer'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import DateTimeColumn from 'types/table/DateTimeColumn'
import Sort from 'lib/psfs/Sort'
import { formatMessage } from 'lib/intl'

class Index extends ListFromTable {
  constructor(props) {
    super(props)
    this.getTableData = props.auditFetchTable
    this.getTableFilters = props.auditFetchTableFilters
    this.clearReducerState = props.auditClearStateList
    this.asyncData = true
    this.loadingData = true
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (this.props.tableData !== nextProps.tableData) {
      this.loadingData = false
    }

    return super.shouldComponentUpdate(nextProps, nextState, nextContext)
  }

  getTableProps() {
    return {
      title: formatMessage('audit'),
      showFilterBar: true,
      sorting: true,
      paging: true,
      searching: true,
      filtering: true,
    }
  }

  getColumns() {
    const columns = new ColumnCollection()

    columns.add(
      new Column('user', formatMessage('user'), {
        sorting: true,
        defaultSort: true,
        defaultSortOrder: Sort.ASC,
      }),
    )
    columns.add(
      new Column('message', formatMessage('message'), { sorting: true }),
    )
    columns.add(
      new Column('client_ip', formatMessage('user_ip'), { sorting: true }),
    )
    columns.add(
      new DateTimeColumn('date', formatMessage('create_date'), {
        sorting: true,
      }),
    )

    return columns
  }

  getFilters() {
    return this.props.tableFilters.toArray()
  }
}

export default connect(
  state => ({
    tableData: state.getIn(['audit', 'tableData']),
    tableFilters: state.getIn(['audit', 'tableFilters']),
  }),
  {
    auditFetchTable,
    auditFetchTableFilters,
    auditClearStateList,
  },
)(Index)
